import AoneService from "../axiosbase";

export const getCountries = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/" + params);
  } catch (error) {
    return error;
  }
};

export const getCountryData = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/" + params);
  } catch (error) {
    return error;
  }
};

//filter countries
export const filterCountries = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/filter" + params);
  } catch (error) {
    return error;
  }
};

//export countries
export const exportCountries = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//export region
export const exportRegion = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/regions/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//export cities
export const exportCities = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/cities/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//export district
export const exportDistrict = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/districts/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

export const postCountries = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/countries/", data);
  } catch (error) {
    return error;
  }
};

export const getCountryById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/" + params);
  } catch (error) {
    return error;
  }
};

export const getCountryByCity = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/countries/${params}/cities`);
  } catch (error) {
    return error;
  }
};

export const filterCountryByCity = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/countries/filter/${params}/cities`);
  } catch (error) {
    return error;
  }
};

export const getDesCountryByCity = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/countries/${params}/cities`);
  } catch (error) {
    return error;
  }
};

export const getCityById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/cities/" + params);
  } catch (error) {
    return error;
  }
};

export const getDistrictById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/districts/" + params);
  } catch (error) {
    return error;
  }
};

//get district geometry
export const getDistrictGeometry = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/districts/${params}/geometry`);
  } catch (error) {
    return error;
  }
};

//edit district geometry
export const editDistrictGeometry = async (params,data) => {
  try {
    return await AoneService.put(`addresses/api/v1/districts/${params}/geometry`,data);
  } catch (error) {
    return error;
  }
};

//download country template
export const getCountryTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/countries/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//download region template
export const getRegionTemplate = async () => {
  try {
    return await AoneService.get("addresses/api/v1/regions/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//download city template
export const getCitiesTemplate = async () => {
  try {
    return await AoneService.get("addresses/api/v1/cities/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//post cities
export const postCities = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/cities/", data);
  } catch (error) {
    return error;
  }
};

//download district template
export const getDistrictTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/districts/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//post district
export const postDistrict = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/districts/", data);
  } catch (error) {
    return error;
  }
};

//country import
export const importCountry = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/countries/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//region import
export const importRegion = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/regions/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//city import
export const importCity = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/cities/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//district import
export const importDistrict = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/districts/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

export const importCityShortAddress = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/cities/import/short-address`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

export const importDistrictShortAddress = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/districts/import/short-address`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

export const updateCountryById = async (params, data) => {
  try {
    return await AoneService.put("addresses/api/v1/countries/" + params, data);
  } catch (error) {
    return error;
  }
};

export const updateRegionById = async (params, data) => {
  try {
    return await AoneService.put("addresses/api/v1/regions/" + params, data);
  } catch (error) {
    return error;
  }
};

export const updateCityById = async (params, data) => {
  try {
    return await AoneService.put("addresses/api/v1/cities/" + params, data);
  } catch (error) {
    return error;
  }
};

export const updateDistrictById = async (params, data) => {
  try {
    return await AoneService.put("addresses/api/v1/districts/" + params, data);
  } catch (error) {
    return error;
  }
};

export const deleteCountryById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/countries/" + params);
  } catch (error) {
    return error;
  }
};

export const deleteCityById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/cities/" + params);
  } catch (error) {
    return error;
  }
};

export const deleteDistrictById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/districts/" + params);
  } catch (error) {
    return error;
  }
};

export const getRegions = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/regions/" + params);
  } catch (error) {
    return error;
  }
};

export const getRegion = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/regions/" + params);
  } catch (error) {
    return error;
  }
};

export const getRegionbyCountry = async (params) => {
  try {
    return await AoneService.get(`/addresses/api/v1/regions/${params}/country`);
  } catch (error) {
    return error;
  }
};

export const filterRegions = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/regions/filter" + params);
  } catch (error) {
    return error;
  }
};

export const postRegions = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/regions/", data);
  } catch (error) {
    return error;
  }
};

export const getRegionById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/regions/" + params);
  } catch (error) {
    return error;
  }
};

export const deleteRegionById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/regions/" + params);
  } catch (error) {
    return error;
  }
};

export const getDistricts = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/districts/" + params);
  } catch (error) {
    return error;
  }
};

export const filterDistricts = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/districts/filter" + params);
  } catch (error) {
    return error;
  }
};

export const getCities = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/cities/" + params);
  } catch (error) {
    return error;
  }
};

export const filterCities = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/cities/filter" + params);
  } catch (error) {
    return error;
  }
};

//get region by country id
export const getRegionbyCode = async (params) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/${params}/regions`
    );
  } catch (error) {
    return error;
  }
};

//filter region by country
export const filterRegionbyCode = async (params) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/filter/${params}/regions`
    );
  } catch (error) {
    return error;
  }
};

export const getRegionbyCodeDes = async (params) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/filter/${params}/regions`
    );
  } catch (error) {
    return error;
  }
};

//get city by country id and region id
export const getCitybyCode = async (params, params2) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/${params}/regions/${params2}/cities`
    );
  } catch (error) {
    return error;
  }
};

export const filterCitybyCode = async (params, params2) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/filter/${params}/regions/${params2}/cities`
    );
  } catch (error) {
    return error;
  }
};

export const getCitybyCodeDes = async (params, params2) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/filter/${params}/regions/${params2}/cities`
    );
  } catch (error) {
    return error;
  }
};

//get district by country id, region id,city id
export const getDistrictbyCode = async (params, params2, params3) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/${params}/regions/${params2}/cities/${params3}/districts`
    );
  } catch (error) {
    return error;
  }
};

export const filterDistrictbyCode = async (params, params2, params3) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/filter/${params}/regions/${params2}/cities/${params3}/districts`
    );
  } catch (error) {
    return error;
  }
};

export const getDistrictDesbyCode = async (params, params2, params3) => {
  try {
    return await AoneService.get(
      `addresses/api/v1/countries/filter/${params}/regions/${params2}/cities/${params3}/districts`
    );
  } catch (error) {
    return error;
  }
};

//get tiers
export const getTiers = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/tiers" + params);
  } catch (error) {
    return error;
  }
};

//export tiers
export const exportTier = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/tiers/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//post tiers
export const postTiers = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/tiers", data);
  } catch (error) {
    return error;
  }
};

//get tiers by id
export const getTiersbyId = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/tiers/${params}`);
  } catch (error) {
    return error;
  }
};

//edit tiers
export const updateTiersById = async (params, data) => {
  try {
    return await AoneService.put(`addresses/api/v1/tiers/${params}`, data);
  } catch (error) {
    return error;
  }
};

//delete tiers
export const deleteTiers = async (params) => {
  try {
    return await AoneService.delete(`addresses/api/v1/tiers/${params}`);
  } catch (error) {
    return error;
  }
};

//get od-pair
export const getOdTier = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/od-pair" + params);
  } catch (error) {
    return error;
  }
};

//post od-pair
export const postOdTier = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/od-pair", data);
  } catch (error) {
    return error;
  }
};

//validate od pair
export const validateOdpair = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/od-pair/validate/${params}`);
  } catch (error) {
    return error;
  }
};

//edit od-pair
export const updateOdTierById = async (params, data) => {
  try {
    return await AoneService.put(`addresses/api/v1/od-pair/${params}`, data);
  } catch (error) {
    return error;
  }
};

//delete od-pair
export const deleteOdTier = async (params) => {
  try {
    return await AoneService.delete(`addresses/api/v1/od-pair/${params}`);
  } catch (error) {
    return error;
  }
};

//get country mapping
export const getCountryMapping = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/mapping" + params);
  } catch (error) {
    return error;
  }
};

//post country mapping
export const postCountryMapping = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/countries/mapping", data);
  } catch (error) {
    return error;
  }
};

//delete country mapping
export const deleteCountryMappingById = async (params) => {
  try {
    return await AoneService.delete(
      "addresses/api/v1/countries/mapping/" + params
    );
  } catch (error) {
    return error;
  }
};

//get country mapping by id
export const getCountryMappingById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/countries/mapping" + params);
  } catch (error) {
    return error;
  }
};

//put country mapping
export const updateCountryMappingById = async (params, data) => {
  try {
    return await AoneService.put(
      "addresses/api/v1/countries/mapping/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//get region mapping
export const getRegionMapping = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/region/mapping" + params);
  } catch (error) {
    return error;
  }
};

//post region mapping
export const postRegionMapping = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/region/mapping", data);
  } catch (error) {
    return error;
  }
};

//delete region mapping
export const deleteRegionMappingById = async (params) => {
  try {
    return await AoneService.delete(
      "addresses/api/v1/region/mapping/" + params
    );
  } catch (error) {
    return error;
  }
};

//get region mapping by id
export const getRegionMappingById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/region/mapping" + params);
  } catch (error) {
    return error;
  }
};

//put region mapping
export const updateRegionMappingById = async (params, data) => {
  try {
    return await AoneService.put(
      "addresses/api/v1/region/mapping/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//get city mapping
export const getCityMapping = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/city/mappings" + params);
  } catch (error) {
    return error;
  }
};

//post city mapping
export const postCityMapping = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/city/mappings", data);
  } catch (error) {
    return error;
  }
};

//delete city mapping
export const deleteCityMappingById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/city/mappings/" + params);
  } catch (error) {
    return error;
  }
};

//get city mapping by id
export const getCityMappingById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/city/mappings" + params);
  } catch (error) {
    return error;
  }
};

//put city mapping
export const updateCityMappingById = async (params, data) => {
  try {
    return await AoneService.put(
      "addresses/api/v1/city/mappings/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//get district mapping
export const getDistrictMapping = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/district/mapping" + params);
  } catch (error) {
    return error;
  }
};

//post district mapping
export const postDistrictMapping = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/district/mapping", data);
  } catch (error) {
    return error;
  }
};

//delete district mapping
export const deleteDistrictMappingById = async (params) => {
  try {
    return await AoneService.delete(
      "addresses/api/v1/district/mapping/" + params
    );
  } catch (error) {
    return error;
  }
};

//get district mapping by id
export const getDistrictMappingById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/district/mapping" + params);
  } catch (error) {
    return error;
  }
};

//put district mapping
export const updateDistrictMappingById = async (params, data) => {
  try {
    return await AoneService.put(
      "addresses/api/v1/district/mapping/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//mapping templates
//download country template
export const getCountryMapTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/countries/mapping/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getRegionMapTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/region/mapping/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getCityMapTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/city/mapping/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getDistrictMapTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/district/mapping/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//export mapping template
export const exportDistrictMap = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/district/mapping/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const exportCountryMap = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/countries/mapping/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const exportRegionMap = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/region/mapping/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const exportCityMap = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/city/mapping/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importCountryMap = async (data) => {
  try {
    return await AoneService.post(
      `addresses/api/v1/countries/mapping/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importRegionMap = async (data) => {
  try {
    return await AoneService.post(
      `addresses/api/v1/region/mapping/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importCityMap = async (data) => {
  try {
    return await AoneService.post(
      `addresses/api/v1/city/mapping/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

export const importDistrictMap = async (data) => {
  try {
    return await AoneService.post(
      `addresses/api/v1/district/mapping/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//get service zone groups by hubs
export const getAllZonegroupbyHub = async (params) => {
  try {
    return await AoneService.get(`addresses/api/v1/zones/groups/hubs/${params}`);
  } catch (error) {
    return error;
  }
};

//get currency
export const getCurrency = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/currency" + params);
  } catch (error) {
    return error;
  }
};

export const filterCurrency = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/currency/filter" + params);
  } catch (error) {
    return error;
  }
};

//post currency
export const postCurrency = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/currency", data);
  } catch (error) {
    return error;
  }
};

//delete currency
export const deleteCurrencyById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/currency/" + params);
  } catch (error) {
    return error;
  }
};

//put currency
export const updateCurrencyById = async (params, data) => {
  try {
    return await AoneService.put("addresses/api/v1/currency/" + params, data);
  } catch (error) {
    return error;
  }
};

//currency template
export const getCurrencyTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/currency/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//export currency
export const exportCurrency = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/currency/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//import currency
export const importCurrency = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/currency/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//get currency conversions
export const getCurrencyConversion = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/currency/conversion" + params
    );
  } catch (error) {
    return error;
  }
};

//post currency
export const postCurrencyConversion = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/currency/conversion", data);
  } catch (error) {
    return error;
  }
};

//delete currency
export const deleteCurrencyConversionById = async (params) => {
  try {
    return await AoneService.delete(
      "addresses/api/v1/currency/conversion/" + params
    );
  } catch (error) {
    return error;
  }
};

//put currency
export const updateCurrencyConversionById = async (params, data) => {
  try {
    return await AoneService.put(
      "addresses/api/v1/currency/conversion/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//currency template
export const getCurrencyConversionTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/currency/conversion/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//export currency
export const exportCurrencyConversion = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/currency/conversion/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//import currency
export const importCurrencyConversion = async (data) => {
  try {
    return await AoneService.post(
      `addresses/api/v1/currency/conversion/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//get zone
export const getZone = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/zones" + params);
  } catch (error) {
    return error;
  }
};

//filter Zone
export const filterZone = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/zones/filter" + params);
  } catch (error) {
    return error;
  }
};

//getbyId-zone
export const getZoneById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/zones/" + params);
  } catch (error) {
    return error;
  }
};

//post zones
export const postZones = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/zones", data);
  } catch (error) {
    return error;
  }
};

//update zones
export const updateZoneById = async (params, data) => {
  try {
    return await AoneService.put("addresses/api/v1/zones/" + params, data);
  } catch (error) {
    return error;
  }
};

//delete zones
export const deleteZoneById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/zones/" + params);
  } catch (error) {
    return error;
  }
};

//zone template
export const getZoneTemplate = async () => {
  try {
    return await AoneService.get("addresses/api/v1/zones/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//zone export
export const exportZones = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/zones/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//zone import
export const importZones = async (data) => {
  try {
    return await AoneService.post(`addresses/api/v1/zones/import`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//zone groups
export const getZoneGroups = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/zones/groups" + params);
  } catch (error) {
    return error;
  }
};

//getbyId-zone group
export const getZoneGroupById = async (params) => {
  try {
    return await AoneService.get("addresses/api/v1/zones/groups/" + params);
  } catch (error) {
    return error;
  }
};

//post zonegroup
export const postZonegroup = async (data) => {
  try {
    return await AoneService.post("addresses/api/v1/zones/groups", data);
  } catch (error) {
    return error;
  }
};

//update zonegroup
export const updateZonegroupById = async (params, data) => {
  try {
    return await AoneService.put(
      "addresses/api/v1/zones/groups/" + params,
      data
    );
  } catch (error) {
    return error;
  }
};

//delete zonegroup
export const deleteZonegroupById = async (params) => {
  try {
    return await AoneService.delete("addresses/api/v1/zones/groups/" + params);
  } catch (error) {
    return error;
  }
};

//zone group template
export const getZonegroupTemplate = async () => {
  try {
    return await AoneService.get(
      "addresses/api/v1/zones/groups/template/download",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//zone group export
export const exportZonegroup = async (params) => {
  try {
    return await AoneService.get(
      "addresses/api/v1/zones/groups/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//zone group import
export const importZonegroup = async (data) => {
  try {
    return await AoneService.post(
      `addresses/api/v1/zones/groups/import`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};
